export const cleanGroup = (
  group: APICustomFieldGroup
): CustomFieldGroupPUTUpdate => {
  const copy = { ...group }
  delete copy.created_by
  if (copy.description.length === 0) {
    copy.description = null
  }
  return copy
}
